import { combineReducers } from 'redux';

import alertMessageReducer from './alertMessage/reducer';
import helperReducer from './helper/reducer';
import notificationsReducer from './notifications/reducer';
import formDataPorfile from './porfile/reducer';
import userReducer from './user/reducer';

const rootReducer = combineReducers({
  user: userReducer,
  alert: alertMessageReducer,
  helperReducer: helperReducer,
  formDataPorfile: formDataPorfile,
  notifications: notificationsReducer,
});

export default rootReducer;
